
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.728 9.182a.75.75 0 00-1.456-.364L13.94 22.151a.75.75 0 101.455.364l3.334-13.333zM11.864 12.864a.75.75 0 00-1.061-1.061L7.47 15.136a.75.75 0 000 1.061l3.333 3.333a.75.75 0 001.06-1.06l-2.802-2.803 2.803-2.803zM21.864 11.803a.75.75 0 00-1.061 1.06l2.803 2.804-2.803 2.803a.75.75 0 101.06 1.06l3.334-3.333a.75.75 0 000-1.06l-3.333-3.334z","fill":"#A4A8C0"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16zm16 14.5C7.992 30.5 1.5 24.008 1.5 16S7.992 1.5 16 1.5 30.5 7.992 30.5 16 24.008 30.5 16 30.5z","fill":"#A4A8C0"}})])
          )
        }
      }
    